import React, { memo } from "react";
import ToolTip from "@mui/material/Tooltip";
import { View, Text, StyleSheet, FlatList } from "react-native";
import { FONT_FAMILY, THEME_COLORS } from "../themes";

interface Props {
  partCount: string;
  partDetails: any[];
}

const skuHeader = ["SKU ID", "Cost"];

const PartDetailsToolTip = ({ partCount, partDetails }: Props) => {
  const headerComponentSku = (
    <View
      style={{
        flexDirection: "row",
        paddingVertical: 10,
        borderRadius: 8,
        backgroundColor: "#F8F7FF",
      }}
    >
      {skuHeader.map((item, i) => (
        <View key={i} style={{ flex: 1, paddingHorizontal: 10 }}>
          <Text style={{ fontSize: 15, fontFamily: FONT_FAMILY.three }}>{item}</Text>
        </View>
      ))}
    </View>
  );

  return (
    <ToolTip
      slotProps={{
        tooltip: {
          sx: { padding: "0rem", borderRadius: 5, background: "red" },
        },
      }}
      placement="bottom"
      title={
        partDetails?.length ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: "white",
              padding: 10,
              boxShadow: "4px 4px 24px rgba(0, 0, 0, 0.08)",
              borderRadius: 5,
            }}
          >
            <Text
              style={{
                fontFamily: FONT_FAMILY.four,
                fontSize: 15,
                marginBottom: 10,
                marginTop: 5,
                letterSpacing: 0.3,
                marginLeft: 5,
              }}
            >
              SKU Details
            </Text>
            <FlatList
              ListHeaderComponent={headerComponentSku}
              data={partDetails || []}
              keyExtractor={(_) => _.id?.toString()}
              renderItem={({ item: row }: any) => (
                <View
                  style={{
                    flexDirection: "row",
                    paddingVertical: 15,
                    backgroundColor: "white",
                  }}
                >
                  <View style={{ flex: 1, paddingHorizontal: 15 }}>
                    <Text style={[styles.rowText, { fontSize: 13 }]}>{row ? row?.sku : "--"}</Text>
                  </View>
                  <View style={{ flex: 1, paddingHorizontal: 15 }}>
                    <Text style={[styles.rowText, { fontSize: 13 }]}>{row?.sku_dict?.cost}</Text>
                  </View>
                </View>
              )}
            />
          </div>
        ) : (
          ""
        )
      }
    >
      <Text
        style={[
          styles.rowText,
          { color: THEME_COLORS.primaryPurple, textDecorationLine: "underline", fontFamily: FONT_FAMILY.three },
        ]}
      >
        {partCount}
      </Text>
    </ToolTip>
  );
};

const styles = StyleSheet.create({
  rowText: {
    fontFamily: FONT_FAMILY.two,
    fontSize: 15,
    letterSpacing: 0.1,
  },
});

export default memo(PartDetailsToolTip);
